import React, { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Image, Upload, UploadProps } from 'antd';
import ImgCrop from 'antd-img-crop';

import { getSrc, prepareSrc } from '../../../utils/common/getSrc';
import getEnvConfig from '../../../utils/config/env';
import { UploadButton } from '../../widgets/UploadButton';

interface ImageUpload {
    formik: any;
    fieldName: string;
    isEdit?: boolean;
}
export const ImageUpload = (props: ImageUpload) => {
    const { formik, isEdit, fieldName } = props;

    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState<string>(formik?.values?.image);

    useEffect(() => {
        setImageUrl(formik?.values?.image);
    }, [formik?.values?.image]);

    const dummyRequest = async onSuccess => {
        setTimeout(() => {
            onSuccess('ok');
        }, 0);
    };

    const getBase64 = (img, callback: (url: string) => void) => {
        const reader = new FileReader();
        reader.addEventListener('load', () =>
            callback(reader.result as string)
        );
        reader.readAsDataURL(img);
    };

    const handleChange: UploadProps['onChange'] = info => {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, url => {
                setLoading(false);
                setImageUrl(url);
            });
        }
    };

    return (
        <ImgCrop
            rotationSlider
            quality={0.75}
            showReset
            showGrid
            modalTitle={'Отредактируйте изображение'}
            modalOk={'Применить'}
            resetText={'Отменить изменения'}
        >
            <Upload
                name='avatar'
                maxCount={1}
                customRequest={file => {
                    void dummyRequest(file.onSuccess);
                }}
                beforeUpload={file => {
                    formik.setFieldValue(fieldName, file);
                }}
                onChange={handleChange}
                listType='picture-card'
                showUploadList={false}
            >
                {imageUrl ? (
                    <Col span={24}>
                        <Image
                            preview={false}
                            src={
                                isEdit &&
                                (typeof formik.values.image !== 'object' ||
                                    typeof formik.values[fieldName] !==
                                        'object')
                                    ? getSrc(
                                          imageUrl,
                                          `storage/telegram_bot/${formik.values.shop_id}`
                                      )
                                    : imageUrl
                            }
                        />
                    </Col>
                ) : (
                    <UploadButton />
                )}
            </Upload>
        </ImgCrop>
    );
};
